<template>
  <div class="container">
    <img src="../../assets/img/sale-bannar1.png" width="100%" alt="">
    <!-- <Modular obj="sale" name="modular1"></Modular> -->
    <Modular obj="sale" name="modular2"></Modular>
    <Modular obj="sale" name="modular3"></Modular>
    <Modular obj="sale" name="modular4"></Modular>
    <Modular obj="sale" name="modular5"></Modular>
    <Modular obj="sale" name="modular6"></Modular>
    <!-- <img src="../../assets/img/sale-bannar2.png" width="100%" alt="" style="margin-bottom: -10px;"> -->
  </div>
</template>
<script>
import Modular from '../../components/Modular'
import News from '../../components/MNews'
export default {
  components: {
    Modular,
    News
  },
  data(){
    return {}
  },
  created(){
  },
  methods:{
  }
}
</script>

<style lang="scss">
.container{
    p{
        text-align: center;
    }
}
</style>
